<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'DIRECTORY-SEARCH-KNO2'" [breadcrumb]="''" [count]=""
    icon="fa-search-location">
</app-breadcrumb>
<app-kno2-search [allowSelection]="false" [showOrganizationsTab]="true"></app-kno2-search>